// import { Landing } from "@/blocks/Landing/Landing";

import Spinner from "@/components/Spinner";
import dynamic from "next/dynamic";

import Landing from "@/blocks/Landing/Landing";

// const DynamicLanding = dynamic(() => import("@/blocks/Landing/Landing"), {
// 	ssr: false, // optional: disable SSR if the component depends on `window`
// 	loading: () => <Spinner loading={true}><></></Spinner>
// });

export default function LandingWrapper({ id, heading, video, image, mobileImage, minHeight, mobileVideo, animated, animationType, mute, restrictHeight = true, ...props }: { id: string, heading: string, video: string, image: string, mobileImage: string, minHeight: string, mobileVideo: string, animated: boolean, animationType: string, mute: boolean, restrictHeight: boolean }) {

  const placeholderImage = {
    width: 500,
    height: 500,
    src: image
  };

  const mobilePlaceholderImage = {
    width: 300,
    height: 300,
    src: mobileImage
  };

  return (
    <div className='hero w-full relative overflow-hidden' id={id}>
      <Landing heading={heading}
        mobileVideo={mobileVideo}
        restrictHeight={restrictHeight}
        video={video}
        minHeight={minHeight}
        animated={animated}
        animation={animationType}
        image={placeholderImage}
        mobileImage={mobilePlaceholderImage}
        muted={mute}
      ></Landing>
    </div>
  )
}